module.exports = __webpack_public_path__ + "static/media/work-squid.d1e24a87.svg";